import React from "react";
import ReactApexChart from "react-apexcharts";

const SpecialAreaChartForKPI04 = ({ kpi }) => {
  const series = [
    {
      name: kpi.kpi_code,
      data: [
        kpi.avg_target_performance,
        kpi.avg_actual_performance,
        kpi.avg_internal_benchmark,
        kpi.avg_external_benchmark,
        kpi.avg_new_target_performance,
      ],
    },
  ];

  const categories = [
    "Avg Target",
    "Avg Actual",
    "Internal Benchmark",
    "External Benchmark",
    "New Target",
  ];

  const color = "#2C3E50";

  const options = {
    chart: {
      height: 350,
      type: "area",
      toolbar: {
        show: false,
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      width: [3],
      colors: [color],
      curve: "smooth",
    },
    xaxis: {
      categories: categories,
      title: {
        text: "المؤشر",
        style: {
          fontSize: "14px",
          fontFamily: "Cairo",
        },
      },
      labels: {
        style: {
          fontFamily: "Cairo",
        },
      },
    },
    yaxis: {
      labels: {
        formatter: (val) => `${val}`,
      },
      title: {
        style: {
          fontSize: "14px",
          fontFamily: "Cairo",
        },
      },
    },
    markers: {
      size: [6],
      strokeWidth: [3],
      strokeColors: [color],
      colors: ["#fff"],
      hover: {
        size: 8,
      },
    },
    colors: [color],
    tooltip: {
      y: {
        formatter: (val) => `${val}`,
      },
    },
  };

  return (
    <div className="card mt-4 p-3">
      <h5 className="mb-3">{kpi.kpi_code}</h5>
      <ReactApexChart options={options} series={series} type="area" height={350} />
    </div>
  );
};

export default SpecialAreaChartForKPI04;
